import { render, staticRenderFns } from "./DialogEditarCategoria.vue?vue&type=template&id=75b85187"
import script from "./DialogEditarCategoria.vue?vue&type=script&lang=js"
export * from "./DialogEditarCategoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports